/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/32/todo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#444"><path pid="0" d="M29 4h-4v3h2v22H5V7h2V4H3a1 1 0 00-1 1v26a1 1 0 001 1h26a1 1 0 001-1V5a1 1 0 00-1-1z"/><path pid="1" data-color="color-2" d="M20 4a4 4 0 00-8 0H9v5h14V4h-3zM15 23a.997.997 0 01-.707-.293L10.586 19 12 17.586l3 3 6-6L22.414 16l-6.707 6.707A.997.997 0 0115 23z"/></g>'
  }
})
